import axios, { AxiosResponse } from "axios"
import { InsertRemesaDeTicketCommandProps } from "./Commands/InsertRemesaDeTicketCommand"

export async function createRemesaDeTicket(
  data: InsertRemesaDeTicketCommandProps
): Promise<AxiosResponse> {
  const resp = await axios.post("/RemesaDeTicket", data)
  return resp
}
